import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { DocumentService } from '@app/shared/services';
import { AmplifyHttpClient } from '@app/shared/services/auth/http.amplify-httpclient';
import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { toBase64 } from '@aws-sdk/util-base64-node';
import { environment } from '@env/environment';
//
import { fetchAuthSession, fetchUserAttributes } from '@aws-amplify/auth';
import * as fileSaver from 'file-saver';
import { Subscription } from 'rxjs';
import heic2any from 'heic2any';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'file-extension-preview',
  templateUrl: './file-extension-preview.component.html',
  styleUrls: ['./file-extension-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileExtensionPreviewComponent implements OnInit, OnDestroy {
  @Input() IconName;
  @Input() isActive;
  filsrData;
  @Input() is_medium_preview = false;

  @Input() link = null;

  @Input() is_large_icon = false;
  @Input() is_full_size_icon = false;
  @Input() is_small_preview = false;

  @Input() file;

  @Input() link_available = false;
  @Input() formFileExtension = false;
  @Input() securityStateObject;
  @Input() security_key;
  @Input() sk;
  @Input() index;
  userId;
  subscription = new Subscription();
  @Output() childToParent = new EventEmitter<object>();
  loadingUrl = 'assets/images/document-loading-image-icon.gif';
  heicfileconverted = false;

  // Worker reference for proper cleanup
  private getFileWorker: Worker | undefined;

  constructor(
    private _inboxService: InboxSettingsService,
    private documentService: DocumentService,
    private cryptoService: CryptoService,
    private dialog: MatDialog,
    private _loginService: LoginStoreEffects,
    private readonly httpService: AmplifyHttpClient,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this._loginService.loginObject.subscribe((state) => {
        if (state && state.data && state.data.id) {
          this.userId = state.data.id;
        }
      })
    );
    this.IconName = this.IconName.toLowerCase();
    if (this.link != null) {
      if (this.link_available) {
        if (this.IconName == 'heic') {
          this.heicfileconverted = true;
          this.heicFileConverted(this.file);
        } else {
          this.filsrData = this.file.link;
        }
      } else {
        this.downloadMyFile(this.file);
      }
    } else if (this.formFileExtension) {
      if (this.file.status != 'Done') return;
      if (this.checkIfImage(this.file.name?.toLowerCase()) || this.file.name?.toLowerCase().includes('.pdf')) {
        if (this.link_available) {
          this.filsrData = this.file.link;
        } else {
          this.heicfileconverted = true;
          this.getUrl(this.file);
        }
      }
    }
  }
  callParentMethod() {
    this.childToParent.emit({ param1: this.file.delete_id, param2: this.index, param3: this.file.name, param4: this.filsrData });
  }
  downloadMyFile(file) {
    let decrypted_file;
    let res = file.link;
    decrypted_file = res.data; //file is not encrypted
    if (decrypted_file.includes('https://s3.us-east-1.amazonaws.com')) {
      const data = {
        data: res,
      };
      this.displayImageWithUrl(data, file);
      return;
    } else {
      if (res.key) {
        const decryption_key = this.cryptoService.decryptWithPassword(res.key, environment.encryption_mask_id);
        decrypted_file = this.cryptoService.decryptFile(decrypted_file, decryption_key);
      }
      this.filsrData = `data:image/${file.name.split('.').pop()};base64,${toBase64(decrypted_file)}`;
      this.cd.detectChanges();
    }
  }
  doSomething() {
    if (this.filsrData == undefined || this.filsrData == null) {
      this.ngOnInit();
    }
  }
  async getUrl(file) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        // Terminate previous worker if exists
        if (this.getFileWorker) {
          this.getFileWorker.terminate();
        }

        this.getFileWorker = new Worker(new URL('./get-file.worker', import.meta.url), { type: 'module' });

        let data = {
          token: '',
          url: '',
        };

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;

        data.url = `${environment.apiUrl}/api/vault/vault-user-form-file-download/${this.userId}/${file.delete_id}`;
        let date = new Date();
        this.getFileWorker.onmessage = ({ data }) => {
          let res = data;

          // Terminate worker after receiving data
          if (this.getFileWorker) {
            this.getFileWorker.terminate();
            this.getFileWorker = undefined;
          }

          if (res.data.data.includes('https://s3.us-east-1.amazonaws.com')) {
            this.displayImageWithUrl(res, file);

            return;
          }
          let decrypted_file;
          let decryption_key;

          if (res.data.premium_encrypted == null || res.data.premium_encrypted == 'url') {
            decrypted_file = res.data.data; //file is not encrypted
          } else if (res.data.premium_encrypted == 'encrypted' || res.data.premium_encrypted == 'pending_decryption') {
            //decrypt file using user's security key
            decryption_key = this.cryptoService.decryptDataKey(res.data.key, this.security_key, this.sk);
            decrypted_file = this.cryptoService.decryptFile(res.data.data, decryption_key);
          } else {
            //get key to decrypt file
            decryption_key = this.cryptoService.decryptWithPassword(res.data.key, environment.encryption_mask_id);
            decrypted_file = this.cryptoService.decryptFile(res.data.data, decryption_key);
          }

          // set data for pdf viewer
          if (this.checkIfImage(file.name)) {
            this.filsrData = `data:image/${file.name.split('.').pop()};base64,${toBase64(decrypted_file)}`;
          } else {
            var fileD = new Blob([decrypted_file], { type: 'application/pdf' });

            var fileURL = URL.createObjectURL(fileD);

            const reader = new FileReader();
            const binaryString = reader.readAsDataURL(fileD);
            reader.onload = (event: any) => {
              //Here you can do whatever you want with the base64 String
              this.filsrData = event.target.result;

              this.cd.markForCheck();
            };

            reader.onerror = (event: any) => {};
            // window.open(fileURL);

            const blob = new Blob([decrypted_file], { type: 'application/octet-stream' });
          }

          this.cd.markForCheck();

          resolve(data);
        };
        this.getFileWorker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPair({}));
      }
    });
  }
  async displayImageWithUrl(res, file) {
    const isHeic = file.name.toLowerCase().includes('.heic');
    if (isHeic) {
      this.heicfileconverted = true;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', res.data.data, true);
      xhr.responseType = 'blob';

      xhr.onload = async () => {
        if (xhr.status != 200) {
          this.displayImageWithUrl(res, file);
          return;
        }

        const fileBlob = xhr.response;

        if (isHeic) {
          const convertedBase64 = await this.convertHeicToBase64(fileBlob);
          if (convertedBase64) {
            this.filsrData = convertedBase64;
            this.cd.detectChanges();
          }
          return; // ✅ STOP: No further processing required for HEIC
        }

        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.showPDFImageProcess(res, event.target.result, file);
          this.cd.detectChanges();
        };
        reader.readAsDataURL(fileBlob); // ✅ Use readAsDataURL to properly process binary files
      };

      xhr.send();
    } else if (res.data.premium_encrypted != 'none' && !(res.data.premium_encrypted == null && res.data.key == null)) {
      // this.filsrData = decrypted_file;
      var xhr = new XMLHttpRequest();

      xhr.open('GET', res.data.data, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status != 200) {
          this.displayImageWithUrl(res, file);
          return;
        }
        var reader = new FileReader();
        reader.onload = (event: any) => {
          // this.filsrData = event.target.result;

          this.showPDFImageProcess(res, event.target.result, file);
          this.cd.detectChanges();
        };
        var file1 = xhr.response;

        reader.readAsText(file1);
      };
      xhr.send();
    } else {
      if (this.file.name.toLowerCase().includes('.pdf')) {
        this.filsrData = res.data.data;
        this.cd.detectChanges();
        return;
      } else {
        if (file.name.includes('.heic')) {
          const convertedBase64 = await this.convertHeicToBase64(xhr.response);
          if (convertedBase64) {
            this.filsrData = convertedBase64;
            this.cd.detectChanges(); // Very important to update the view
          }
        }
        // this.filsrData = decrypted_file;
        var xhr = new XMLHttpRequest();

        xhr.open('GET', res.data.data, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.filsrData = event.target.result;
            this.cd.detectChanges();
          };
          var file1 = xhr.response;

          reader.readAsDataURL(file1);
        };
        xhr.send();
      }
    }
  }
  showPDFImageProcess(data, fileData, file) {
    let res = data;
    let decrypted_file;
    let decryption_key;

    if (res.data.premium_encrypted == 'encrypted' || res.data.premium_encrypted == 'pending_decryption') {
      //decrypt file using user's security key
      decryption_key = this.cryptoService.decryptDataKey(res.data.key, this.security_key, this.sk);
      decrypted_file = this.cryptoService.decryptFile(fileData, decryption_key);
    } else {
      //get key to decrypt file
      decryption_key = this.cryptoService.decryptWithPassword(res.data.key, environment.encryption_mask_id);
      decrypted_file = this.cryptoService.decryptFile(fileData, decryption_key);
    }
    if (this.checkIfImage(file.name)) {
      this.filsrData = `data:image/${file.name.split('.').pop()};base64,${toBase64(decrypted_file)}`;
    } else {
      var fileD = new Blob([decrypted_file], { type: 'application/pdf' });

      var fileURL = URL.createObjectURL(fileD);

      const reader = new FileReader();
      const binaryString = reader.readAsDataURL(fileD);
      reader.onload = (event: any) => {
        //Here you can do whatever you want with the base64 String
        this.filsrData = event.target.result;

        this.cd.markForCheck();
      };

      const blob = new Blob([decrypted_file], { type: 'application/octet-stream' });
    }
  }
  generateDataKeyPair(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  bufferToBase64(buf) {
    var binstr = Array.prototype.map
      .call(buf, function (ch) {
        return String.fromCharCode(ch);
      })
      .join('');
    return btoa(binstr);
  }
  checkIfImage(fileName) {
    if (fileName != undefined) {
      const fileNameFormated = fileName.toLowerCase();
      if (
        fileNameFormated.includes('jpeg') ||
        fileNameFormated.includes('png') ||
        fileNameFormated.includes('jpg') ||
        fileNameFormated.includes('heic') ||
        fileNameFormated.includes('giff')
      ) {
        return true;
      }
      return false;
    }
    return false;
  }
  async heicFileConverted(file) {
    const jpegBase64 = await this.convertHeicUrlToJpeg(file.link);
    if (jpegBase64) {
      this.heicfileconverted = true;
      this.filsrData = jpegBase64; // ✅ Show preview
    } else {
      console.error('Could not convert HEIC file.');
    }
    this.cd.detectChanges();
  }
  async convertHeicToBase64(fileBlob: Blob): Promise<string | null> {
    try {
      const convertedBlob = await heic2any({ blob: fileBlob, toType: 'image/jpeg' });
      return await this.blobToBase64(convertedBlob as Blob);
    } catch (error) {
      console.error('HEIC conversion failed: ', error);
      return null;
    }
  }
  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }
  async convertHeicUrlToJpeg(url: string): Promise<string | null> {
    try {
      const fileBlob = await this.fetchBlobFromUrl(url);
      const jpegBase64 = await this.convertHeicToBase64(fileBlob);
      return jpegBase64;
    } catch (error) {
      console.error('Error converting HEIC to JPEG:', error);
      return null;
    }
  }

  private fetchBlobFromUrl(url: string): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';

      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          reject(`Failed to fetch file. Status: ${xhr.status}`);
        }
      };

      xhr.onerror = () => reject('Network error while fetching file.');
      xhr.send();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();

    // Terminate worker
    if (this.getFileWorker) {
      this.getFileWorker.terminate();
      this.getFileWorker = undefined;
    }
  }
}
